<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { useGetMemoryWarningInfo } from "@/composable/useMemoryWarning";
import { reloadApp } from "@/utils/reloadApp";

const { t } = useTranslation();
const { isMemoryHigh } = useGetMemoryWarningInfo();
</script>

<template>
  <button
    type="button"
    class="reload-app-btn dr-tooltip"
    :data-tooltip="t('dashboard:sync.page.reloadApp.tooltip')"
    :aria-label="t('dashboard:sync.page.reloadApp.label')"
    @click="reloadApp()"
  >
    <el-icon size="18" class="text-dark">
      <i class="bi-arrow-clockwise"></i>
    </el-icon>

    <el-icon v-if="isMemoryHigh" size="1rem" class="absolute-icon-badge">
      <i class="bi-exclamation-triangle-fill text-danger"></i>
    </el-icon>
  </button>
</template>

<style scoped>
.reload-app-btn {
  position: relative;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
}

.absolute-icon-badge {
  position: absolute;
  top: -4px;
  right: -8px;
}
</style>
